import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { environment } from '@environments/environment';
import { NgOptimizedImage } from '@angular/common';
import { DecoIconComponent } from '@shared/components/deco-icon/deco-icon.component';
import { HeaderMixpanelService } from '@shared/mixpanel';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-menu-services[closePopover]',
    templateUrl: './menu-services.component.html',
    styleUrls: ['./menu-services.component.scss'],
    imports: [NgOptimizedImage, DecoIconComponent, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuServicesComponent {
    closePopover = output<void>();

    readonly geneticMonitoringUrl = environment.geneticMonitoring + '/home';
    readonly microbiomeUrl = environment.microbiome + '/home';
    readonly colonyUrl = environment.colonyUrl;
    readonly tagCenterUrl = 'https://tagcenter.info/';
    readonly tissueUrl = 'https://tissue.transnetyx.com/';

    constructor(private mixpanel: HeaderMixpanelService) {}

    goToGeneticMonitoring(): void {
        window.open(this.geneticMonitoringUrl, '_blank');
    }

    goToMicrobiome(): void {
        window.open(this.microbiomeUrl, '_blank');
    }

    goToColony(): void {
        window.open(this.colonyUrl, '_blank');
    }

    goToTagCenter(): void {
        window.open(this.tagCenterUrl, '_blank');
    }

    goToTissue(): void {
        window.open(this.tissueUrl, '_blank');
    }

    close(): void {
        this.closePopover.emit();
    }

    logAction(action: 'genetic-monitoring' | 'microbiome' | 'colony' | 'tag-center' | 'tissue' | 'sequencing') {
        switch (action) {
            case 'genetic-monitoring':
                this.mixpanel.logGeneticMonitoringRedirect();
                break;
            case 'microbiome':
                this.mixpanel.logMicrobiomeRedirect();
                break;
            case 'colony':
                this.mixpanel.logColonyRedirect();
                break;
            case 'tag-center':
                this.mixpanel.logTagCenterRedirect();
                break;
            case 'tissue':
                this.mixpanel.logTissueRedirect();
                break;
            case 'sequencing':
                this.mixpanel.logSequencingRedirect();
                break;
        }
    }
}
